import React from 'react'
import PropTypes from 'prop-types'
import Drawer from 'components/common/Drawer'
import ChangePasswordForm from '../ChangePasswordForm'
import PasswordAndSecurityView from '../PasswordAndSecurityView'

const PasswordAndSecurityDrawer = ({
  accountContactDetails,
  expanded: isEditMode,
  toggleHandlers: {
    onClick: onChangeViewMode
  },
  setFocusScopeRef,
  handleUpdatePassword
}) =>
  <Drawer title="Password & Security" withHeading accordion expandedByDefault preventHandleBlur>
    {
      isEditMode ?
        <ChangePasswordForm
          setFocusScopeRef={ setFocusScopeRef }
          onCancel={ onChangeViewMode }
          onSubmit={ handleUpdatePassword } /> :
        <PasswordAndSecurityView accountContactDetails={ accountContactDetails } onEdit={ onChangeViewMode } />
    }
  </Drawer>

export default PasswordAndSecurityDrawer

PasswordAndSecurityDrawer.propTypes = {
  accountContactDetails: PropTypes.shape(),
  expanded: PropTypes.bool,
  handleUpdatePassword: PropTypes.func,
  setFocusScopeRef: PropTypes.func,
  toggleHandlers: PropTypes.shape({
    onClick: PropTypes.func
  })
}
